var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyDark = function SvgEmptyDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1950,
    height: 1137,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1950v1137H0z"
  })));
};
export { SvgEmptyDark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTk1MCIgaGVpZ2h0PSIxMTM3IiB2aWV3Qm94PSIwIDAgMTk1MCAxMTM3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMCAwSDE5NTBWMTEzN0gwVjBaIiBmaWxsPSIjMTIxMjEyIiBmaWxsLW9wYWNpdHk9IjAiLz4KPC9zdmc+Cg==";